import { useEffect } from "react";

import { LoginScreen } from "./auth/LoginScreen";
import { UpdateBanner } from "./components/UpdateBanner";
import { useSession } from "./auth/useSession";
import { LibraryScreen } from "./library/LibraryScreen";
import { t, useUiLang } from "./i18n";
import { UNAUTHORIZED } from "./lib/api";
import { useRoute } from "./lib/route";
import { ReaderScreen } from "./reader/ReaderScreen";

export default function App() {
  useUiLang();
  const route = useRoute();
  const { state, signIn, signOut, refresh } = useSession();

  // A cookie can expire while the reader is mid-chapter. When it does, every
  // call starts answering 401: come back to the door rather than leaving a
  // half-loaded page that never recovers.
  useEffect(() => {
    const onExpired = () => void refresh();
    window.addEventListener(UNAUTHORIZED, onExpired);
    return () => window.removeEventListener(UNAUTHORIZED, onExpired);
  }, [refresh]);

  // Nothing at all until the server has said whether a password is in use.
  // Flashing a login form at someone who has none is worse than a blank beat.
  if (state.status === "loading") return null;

  if (state.status === "down") {
    return (
      <div className="flex min-h-full items-center justify-center px-6 text-center">
        <div>
          <p className="text-ink">{t("errorNoServer")}</p>
          <p className="mt-1 text-sm text-muted">{state.message}</p>
        </div>
      </div>
    );
  }

  if (state.status === "locked") return <LoginScreen onSubmit={signIn} />;

  const user = state.status === "in" ? state.user : null;

  return (
    <>
      {route.name === "book" ? (
        <ReaderScreen key={route.id} bookId={route.id} />
      ) : (
        <LibraryScreen user={user} onSignOut={signOut} />
      )}
      {/* Outside the screens on purpose: an update is ready for the whole app,
          and a reader must be told about it wherever they happen to be. */}
      <UpdateBanner />
    </>
  );
}
